const pettyCash = {
    getlist: 'pettycash/getlist',
    add: 'pettycash/add',
    update: 'pettycash/update',
    remove: 'pettycash/remove',
    get: 'pettycash/get',
    getall: 'pettycash/getall',
    clearcache: 'pettycash/clear-cache',
}
export default pettyCash
